// Widget Scripts
import planVisitBtn from './js/widgets/planVisitBtn.js';
import mainSlideshow from './js/widgets/mainFeature/mainSlideshow.js';
import funHereSlideshow from './js/widgets/funSlideshow/funHereSlideshow.js';
import seoBlock from './js/widgets/seoBlock.js';
import eventLineup from './js/widgets/eventLineup.js';
import mozaicGalleries from './js/widgets/mozaicGalleries.js';

// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
$(document).ready(function () {
  planVisitBtn();
  if (globalThis.location.pathname === '/') {
    mainSlideshow();
    funHereSlideshow();
    seoBlock();
    eventLineup();
    mozaicGalleries('mozaicGalleryFirst', mozaicGalleryFirstOpts, 4);
    mozaicGalleries('mozaicGallerySecond', mozaicGallerySecondOpts, 3);
  }
});
